module.exports = __webpack_public_path__ + "static/media/chodba3.728f2712.jpg";